import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { Market } from '../../core/markets/market';
import { MarketsService } from '../../core/markets/markets.service';
import { ActionListDialogComponent, ActionListDialogData } from './action-list-dialog.component';
import { ActionsApiService } from './actions.api.service';

@Component({
  template: `
    <h2 mat-dialog-title>
      {{ 'ACTION_LISTS.CHANGE_MARKET_DIALOG.TITLE' | translate: { name: actionList.name } }}
    </h2>
    <mat-dialog-content class="dialog--overflow">
      <mat-spinner [strokeWidth]="4" [diameter]="40" *ngIf="marketsLoading"></mat-spinner>
      <ng-container *ngIf="!marketsLoading">
        <uikit-search-select
          [options]="markets"
          [showSearch]="true"
          [placeholderText]="'ACTION_LISTS.CHANGE_MARKET_DIALOG.SELECT_A_MARKET' | translate"
          [displayProperty]="'name'"
          [selected]="selectedMarket"
          [width]="400"
          (selection)="selectedMarket = $event"
        ></uikit-search-select>
        <p>
          <mat-checkbox [(ngModel)]="confirmed" color="primary">
            {{ 'ACTION_LISTS.CHANGE_MARKET_DIALOG.I_UNDERSTAND_THIS_CANNOT_BE_UNDONE' | translate }}
          </mat-checkbox>
        </p>
      </ng-container>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button color="primary" [disabled]="!selectedMarket || !confirmed" (click)="changeMarket()">
        <ng-container *ngIf="!buttonLoading; else matSpinner">
          {{ 'ACTION_LISTS.CHANGE_MARKET_DIALOG.CHANGE_MARKET' | translate }}
        </ng-container>
        <ng-template #matSpinner>
          <mat-spinner [diameter]="30"></mat-spinner>
        </ng-template>
      </button>
      <button mat-button matDialogClose tabindex="-1" class="close-button">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./action-list-dialog.component.scss', './action-list-actions.component.scss'],
  standalone: false,
})
export class ChangeMarketDialogComponent extends ActionListDialogComponent implements OnInit {
  markets: Market[];
  selectedMarket: Market;
  marketsLoading = true;
  confirmed = false;
  buttonLoading = false;

  constructor(
    public dialogRef: MatDialogRef<ChangeMarketDialogComponent>,
    public router: Router,
    private marketsService: MarketsService,
    private actionsService: ActionsApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: ActionListDialogData,
    private snackbarService: SnackbarService,
  ) {
    super(dialogRef, router);
  }

  ngOnInit(): void {
    this.marketsService.markets.subscribe((markets) => {
      this.marketsLoading = false;
      this.markets = markets;
    });
  }

  changeMarket(): void {
    if (this.buttonLoading) {
      return;
    }

    this.buttonLoading = true;

    let response$: Observable<any>;
    if (this.data && this.data.useBulkActionsMicroservice) {
      response$ = this.actionsService.changeMarketBulkAction(this.actionList.id, this.selectedMarket);
    } else {
      response$ = this.actionsService.changeMarketForList(this.actionList.id, this.selectedMarket);
    }
    response$.subscribe({
      next: () => {
        this.snackbarService.successSnack(
          `Changing market to ${this.selectedMarket.name} for ${this.actionList.name}.`,
        );
        this.dialogRef.close(true);
        this.buttonLoading = false;
      },
      error: () => {
        this.snackbarService.errorSnack(
          `Failed to change to market ${this.selectedMarket.name} for ${this.actionList.name}. Please try again.`,
        );
        this.buttonLoading = false;
      },
    });
  }
}
